import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, from, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { commonService } from '../services/common.service';
import { isPlatformBrowser } from '@angular/common';
import { v4 as uuidv4 } from 'uuid';
import { log } from '@nguniversal/builders/src/ssr-dev-server';
import { LocalStorageService } from 'src/locallocalStorage.service';
@Injectable()
export class HttpInterceptorInterceptor implements HttpInterceptor {
  private uuid: string | null = null;

  constructor(
    private translate: TranslateService,
    private common: commonService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private localStorageService : LocalStorageService

  ) {
        this.uuid = this.uuid = uuidv4();
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes('i18n')) {
      return next.handle(request);
    }

    return from(this.getCompanyIdentifier()).pipe(
      switchMap(companyIdentifier => {
        const headers: any = {
          'AppId': '6',
          'lang': this.translate?.currentLang ?? 'ar',
          'DeviceType': 'bookingLink',
          'DeviceId' : this.uuid,
          'CompanyIdentifier': companyIdentifier,
          ...this.common.customHeader
        };

        const modifiedRequest = request.clone({
          setHeaders: headers
        });

        return next.handle(modifiedRequest);
      })
    );
  }

  private getCompanyIdentifier(): Promise<string | null> {
    return new Promise((resolve) => {
        const companyIdentifier = this.localStorageService.getItem('companyIdentifier');
        resolve(companyIdentifier);
    });
  }
}
